module.exports = __webpack_public_path__ + "media/images/gift-thanks-modal-bg-ramen@3x-8e73f02b81f371b81165a7821e9626b7.png";